import { Schema, Types, model, models } from "mongoose";
import { stringifyFields } from "based-shared/utils/stringify-fields";
export interface IOwnerFee extends Document {
  _id: string;
  chainId: number;
  packageIndex: number;
  listingFee: Schema.Types.Decimal128;
  listingReferralFee: Schema.Types.Decimal128;
  buyFeePer: Schema.Types.Decimal128;
  sellFeePer: Schema.Types.Decimal128;
  finalizeFeePer: Schema.Types.Decimal128;
}

const ownerFeeSchema = new Schema<IOwnerFee>(
  {
    chainId: { type: Number, required: true },
    packageIndex: { type: Number, required: true },
    listingFee: {
      type: Schema.Types.Decimal128,
      default: new Types.Decimal128("0"),
    },
    listingReferralFee: {
      type: Schema.Types.Decimal128,
      default: new Types.Decimal128("0"),
    },
    buyFeePer: {
      type: Schema.Types.Decimal128,
      default: new Types.Decimal128("0"),
    },
    sellFeePer: {
      type: Schema.Types.Decimal128,
      default: new Types.Decimal128("0"),
    },
    finalizeFeePer: {
      type: Schema.Types.Decimal128,
      default: new Types.Decimal128("0"),
    },
  },
  {
    toObject: {
      getters: true,
      versionKey: false,
      transform: (doc, ret: any) => {
        ret.id = ret._id.toString();
        delete ret._id;

        return stringifyFields(ret);
      },
    },
  }
);

ownerFeeSchema.index({ chainId: 1, packageIndex: 1 }, { unique: true });

export const OwnerFeeModel =
  models?.OwnerFee || model<IOwnerFee>("OwnerFee", ownerFeeSchema);
